
import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function ShortListDefaultMessage() 
{
    const { app_user } = useCTAL();
  
    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                    <p>Hi {app_user.FirstName},</p>

                    <p><b>Your Short List doesn't have any Actions yet!</b></p>

                    <p>You can add Actions directly into your Short List using the Text Box labeled 'New Private Action Title' above instead of moving them from your private Long List 
                       or shared Team List. New Actions added directly to your Short List will default to being <u>private</u> and can be moved in-between your
                       Short and Long Lists. </p>
                   
                    <p><b>If you're member of a Team:</b> To add Team Actions, first select the Team from your User List Index and add the new Action at the 
                       top of the screen and click Create. Then click the "Take" option from the Action Dropdown menu.</p>

                    <div class="row mt-1">
                        <div class="col">
                            <a href="#"><img class="list_item_icon" src="./images/info.svg" alt="users" border="0"/></a>
                            <span class="mt-2">Click on the Information icon above for more help.</span>
                        </div>
                    </div>
                    
                    <p></p>

                    <p>Let's get going!</p>
                </small>
            </div>
        </> 
    );
}